import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, Dialog, DialogContent, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { Button } from '@verantos-dev/shared-components';

import { useJobSubmittedModal } from './useJobSubmittedModal';

/**
 * Success confirmation shown after a generate-accuracy job is submitted. The
 * router-state hand-off and dismissal live in `useJobSubmittedModal`.
 */
export const JobSubmittedModal = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const { submittedJob, handleClose } = useJobSubmittedModal();

  if (!submittedJob) {
    return null;
  }

  return (
    <Dialog open onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ textAlign: 'center', p: theme.spacing(6) }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: theme.spacing(3),
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 50, color: theme.palette.success.main }} />
        </Box>

        <Typography variant="h6" sx={{ mb: theme.spacing(2) }}>
          {formatMessage({ id: 'adminProjects.jobSubmittedModal.title' })}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: theme.spacing(3) }}>
          {formatMessage(
            { id: 'adminProjects.jobSubmittedModal.body' },
            { projectName: submittedJob.projectName }
          )}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: theme.spacing(4) }}>
          {formatMessage(
            { id: 'adminProjects.jobSubmittedModal.jobReference' },
            { jobReference: submittedJob.jobReference }
          )}
        </Typography>

        <Button
          id="job-submitted-modal-view-in-projects"
          variant="contained"
          fullWidth
          displayLabel={formatMessage({ id: 'adminProjects.jobSubmittedModal.viewInProjects' })}
          onClickHandler={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};
